var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.root}},[_c('ul',{staticClass:"list clearfix",attrs:{"id":_vm.id}},_vm._l((_vm.cards),function(ref,index){
var title = ref.title;
var description = ref.description;
var image = ref.image;
var url = ref.url;
var data = ref.data;
var type = ref.type;
return _c('item',{key:index,attrs:{"title":title,"description":description,"image":image,"url":url,"data":data,"type":type}})})),_vm._v(" "),(_vm.pages > 1)?_c('gl-pager',{attrs:{"last":_vm.pages},on:{"change":_vm.changePage}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09ca001a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/List.vue
// module id = null
// module chunks = 